import type { CourseModule } from "@/core/types";
import { lektionWerttypen } from "./lektion-01-werttypen";
import { lektionZahlenformate } from "./lektion-02-zahlenformate";
import { lektionDatum } from "./lektion-03-datum";

export const modulDateneingabe: CourseModule = {
  id: "dateneingabe",
  title: "Daten eingeben: Zahl, Text und Datum",
  summary:
    "Der erste rote Faden des Kurses: Ein Wert ist eine Zahl oder ein Datum, kein " +
    "Text mit angehängter Einheit. Die Einheit gehört ins Zahlenformat.",
  level: "Grundlagen",
  lessons: [lektionWerttypen, lektionZahlenformate, lektionDatum],
};
